define(
({
  "select_shipping_method": "Velg fraktmetode"
})
);
